import DmitrySchemeMini from './DmitrySchemeMini';
export default DmitrySchemeMini;